import { BodyText, Grid, Tooltip } from 'ui-toolkit/components';
import { FontAwesomeIconColor } from '../../../../../shared/FontAweomeIconColor/FontAwesomeIconColor';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import styled from 'styled-components';

const BoldSpan = styled.span`
  ${(props) => props.theme.fonts.semiBoldWeight};
`;

export const PaymentPercentageContent: React.FC<{ percent: number; isOwner: boolean }> = ({ percent, isOwner }) => (
  <BodyText>
    Seller customarily pays <BoldSpan>{`${percent}% of ${isOwner ? 'Owner' : 'Lender'}'s Policy.`}</BoldSpan>
  </BodyText>
);

export interface IPaymentPercentageLabelProps {
  isOwner: boolean;
  percent: number;
}

export const PaymentPercentageLabel: React.FC<IPaymentPercentageLabelProps> = ({ isOwner, percent }) => {
  return (
    <Grid columnCount={2} columnWidth={'min-content'} alignItems={'center'}>
      <BodyText>{`Seller Payment of ${isOwner ? 'Owner' : 'Lender'}'s Policy`}</BodyText>
      <Tooltip tooltipContent={<PaymentPercentageContent percent={percent} isOwner={isOwner} />} trigger={'hover'}>
        <FontAwesomeIconColor
          intent={'secondary'}
          icon={faInfoCircle}
          data-test-id={'payment-percentage-tooltip-trigger'}
        />
      </Tooltip>
    </Grid>
  );
};
